/* eslint-disable indent */

import React from 'react';
import QPureComponent from 'QPureComponent';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';
import compose from 'recompose/compose';

import {featurePages, navMainOrder} from 'containers/App/paths';

import quickenLogo from 'assets/thewhiteq.svg';
import simplifiLogo from 'assets/simplifi-logo.svg';
import simplifiLogoText from 'assets/simplifi-text-dark.svg';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import {withStyles} from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import {ThemeProvider} from 'styled-components';

import {isAuthenticated, getDatasetId, getAuthSession} from 'utils/auth/selectors';
import {getLogger} from 'utils/logger';
import {getFeatureFlag, getFeatureFlags} from 'utils/featureFlags/selectors';

import * as datasetActions from 'data/datasets/actions';
import {getProfile} from 'data/profile/actions';
import {getPreferences} from 'data/preferences/actions';
import * as datasetSelectors from 'data/datasets/selectors';
import * as profileSelector from 'data/profile/selectors';
import { getTopTierEntitlement } from 'data/entitlements/entitlementsSelectors';

import QPreferences from 'components/QPreferences';
import QDialogs from 'components/QDialogs';

import { isAcme, isQuicken } from 'isAcme';
import NotificationsNavIcon from 'components/Notifications/NotificationsNavIcon';

import RefreshButton from './RefreshButton';
import QCardToggleButton from './QCardToggleButton';
import ProfileMenu from './ProfileMenu';
import {MainNavItem} from './MainNavItem';
import HelpSupportButton from './HelpSupportButton';

import {styles} from './styles';

const log = getLogger('containers/App/Header/index.js');


class Header extends QPureComponent {

  componentWillMount() {
    // If we are logged in and component is being mounted, check if datasets are
    // loaded. If they are not, assume that page is being refreshed and we
    // need to kickoff retrieval of datasets again.
    if (this.props.authenticated && this.props.datasets.size === 0) {
      this.props.getUserPreferences();
      this.props.getDatasets();
    }
    if (this.props.authenticated && (!this.props.profile || !this.props.profile.userId)) this.props.getProfile();

  }

  componentDidMount() {
    // window.addEventListener('storage', this.storageEventListener);
  }

  componentWillUnmount() {
    // window.removeEventListener('storage', this.storageEventListener);
  }

  goDash = () => {
    this.props.history.push('/');
  };

  //-------------------------------------------------------------------------------------------------------------------

  getSettingsPage = () => {
    const nav = featurePages.find((x) => x.path === '/settings');
    if (nav && (!nav.featureFlag || this.props.featureFlags.get(nav.featureFlag))) {
      return (
        <MainNavItem
          key='nav-item-settings'
          nav={nav}
          selected={this.props.selected}
          classes={this.props.classes}
          iconSize={this.props.theme.components.navigation.iconSize}
          displayNode={
            this.props.selectedAccountNodes && nav.preserveDisplayNode ?
              this.props.selectedAccountNodes[nav.path] : 'all'
          }
        />
      );
    }
      return null;
  };

  inProductNotificationsOnClick = () => {
  };

  render() {
    super.render();

    const {
      authenticated, classes, theme, selected, onMouseEnter, onMouseLeave,
      showRefreshIcon, qCardsOn, hide, selectedAccountNodes, tier, inProductNotifications,
    } = this.props;

    if (!authenticated) {
      log.log('Render nothing if not authenticated (header)');
      return null;
    }

    return (
      <ThemeProvider className={classes.root} theme={theme}>
        <>
          {authenticated &&
          <>
            <AppBar
              id="application-header-bar"
              elevation={0}
              position="fixed"
              className={hide ? classes.staticNav : classes.navbar}
            >
              <div className={classes.appDiv}>
                <div
                  className={classes.logoSection}
                  style={{cursor: hide && 'default' }}
                >
                  <Button
                    id="logo-nav"
                    classes={{
                      root: classes.rootButton,
                      text: classNames({ [classes.textButton]: isQuicken }),
                    }}
                    component={React.forwardRef((props, ref) => hide ?
                      <div
                        {...props}
                        ref={ref}
                      />
                      :
                      <NavLink
                        {...props}
                        innerRef={ref}/>)}
                        to="/"
                        style={{cursor: hide && 'default'}}>
                        {isAcme ?
                          <div style={{display: 'flex', alignItems: 'center'}}>
                            <img
                              src={simplifiLogo}
                              className={classes.logo}
                              alt="Simplifi by Quicken, click to go home"
                            />
                              <img
                                src={simplifiLogoText}
                                className={classes.logoText}
                                alt="Simplifi by Quicken, click to go home"
                              />
                          </div>
                      :
                      <img
                        src={quickenLogo}
                        style={{filter: 'grayscale(1)', height: 32}}
                        alt="quicken logo, click to go home"
                      />
                    }
                  </Button>
                </div>
                <div
                  className={classes.appBarContainer}
                  onMouseEnter={hide ? undefined : onMouseEnter}
                  onMouseLeave={hide ? undefined : onMouseLeave}
                >
                  <Toolbar classes={{ root: classes.toolbar }}>


                    <div className={classes.betaLabel}>
                      {`${this.props.datasetPreferences.kioskmode ? '*' : ''}`}
                    </div>

                    {!hide &&
                    <div className={classes.navItemsHolder}>
                      <div>
                        <div className={classes.navPopover}>
                          {navMainOrder.map((navKey) => {
                            const nav = featurePages.find((x) => x.path === `/${navKey}`);
                            if (nav && (!nav.featureFlag || this.props.featureFlags.get(nav.featureFlag)) &&
                              (!nav.hideOnTiers.length || !nav.hideOnTiers.includes(tier?.id))) {
                              return (
                                <MainNavItem
                                  key={`nav-item-${nav.path}`}
                                  nav={nav}
                                  selected={selected}
                                  style={{paddingBottom: 10}}
                                  classes={classes}
                                  iconSize={theme.components.navigation.iconSize}
                                  displayNode={
                                    selectedAccountNodes && nav.preserveDisplayNode ?
                                      this.props.selectedAccountNodes[nav.path] : 'all'
                                  }
                                />
                              )
                            }
                            return null;
                          })}
                        </div>
                      </div>
                    </div>
                    }
                  </Toolbar>
                </div>
                <div className={classes.navBottomSection}>
                  <div className={classes.navButtonBottom}>
                    {this.props.onQCardsClick &&
                    <QCardToggleButton
                      size={theme.components.navigation.iconSize}
                      classes={{buttonRoot: classes.qCardButton}}
                      qCardsOn={qCardsOn}
                      onClick={this.props.onQCardsClick}
                    />
                    }

                    {isQuicken && <HelpSupportButton classes={classes}/>}

                    {
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////
//////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
////////////////////////
/////////////////////////////////////////////////////
///////////////////////
/////////////////////////////
                    }

                    {showRefreshIcon && !hide &&
                    <RefreshButton
                      id="sync-arrow"
                      classes={{refreshDivButton: classes.navMenuItem}}
                      size={theme.components.navigation.iconSize}
                    />
                    }

                    {!hide && this.getSettingsPage()}

                    {inProductNotifications &&
                      <ButtonBase
                        id="in-product-notifications"
                        className={classes.navMenuItem}
                        onClick={this.inProductNotificationsOnClick}
                      >
                        <NotificationsNavIcon/>
                        <Typography className={classes.navText}>
                          Notifications
                        </Typography>
                      </ButtonBase>
                    }

                    <ProfileMenu classes={classes}/>
                  </div>
                </div>
              </div>
            </AppBar>
          </>
          }
        </>
      </ThemeProvider>
    );
  }
}

Header.propTypes = {
  selected: PropTypes.string,
  selectedAccountNodes: PropTypes.object,
  showRefreshIcon: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  qCardsOn: PropTypes.bool,
  onQCardsClick: PropTypes.func,
  profile: PropTypes.object,
  getProfile: PropTypes.func,
  authenticated: PropTypes.bool,
  datasets: PropTypes.object,
  getDatasets: PropTypes.func,
  getUserPreferences: PropTypes.func,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object,
  datasetPreferences: PropTypes.object,
  inProductNotifications: PropTypes.bool,
  hide: PropTypes.bool,
  tier: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    datasets: datasetSelectors.getSortedDatasets(state),
    profile: profileSelector.getProfile(state),

    authenticated: isAuthenticated(state),
    datasetId: getDatasetId(state),
    authSession: getAuthSession(state),
    featureFlags: getFeatureFlags(state),
    inProductNotifications: getFeatureFlag(state, 'inProductNotifications'),
    tier: getTopTierEntitlement(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getProfile: () => dispatch(getProfile()),
    getDatasets: () => dispatch(datasetActions.getDatasets()),
    getUserPreferences: () => {
      dispatch(getPreferences({section: 'shared', group: 'user'}));
    },
  };
}

export default compose(
  withStyles(styles, {name: 'Header', withTheme: true}),
  QPreferences(),
  QDialogs(),
)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)));
